import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApplicationMethodEnum } from '@hrra/common-models';

@Component({
  selector: 'app-jobseeker-login-registration-dialog',
  templateUrl: './jobseeker-login-registration-dialog.component.html',
  styleUrl: './jobseeker-login-registration-dialog.component.scss',
  standalone: false,
})
export class JobseekerLoginRegistrationDialogComponent {

  public applyMethodEnum: any;

  constructor(
    public dialogRef: MatDialogRef<JobseekerLoginRegistrationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedTab: number, applyMethod: number }
  ) {
    this.applyMethodEnum = ApplicationMethodEnum;
  }

  close() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close();
  }
}
